import createStringFacet from '../createStringFacet';

export default createStringFacet({
  stateKey: 'blendTypes',
  itemKey: (item) => {
    const varietyCount = item?.grapeVarieties?.length;
    if (varietyCount === 1) return 'single variety';
    if (varietyCount > 1) return 'blend';
    return undefined;
  },
});
